import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

const Title = styled.h1`
  text-align: left;
  font: normal normal 600 28px/42px Source Sans Pro;
  color: #323232;
  margin: ${(props) => props.margin || '0px'};
  margin-right: 16px;
`;

function TitlePage({ label, margin }) {
  return <Title margin={margin}>{label}</Title>;
}
export default TitlePage;

TitlePage.propTypes = {
  label: PropTypes.string.isRequired,
};
